<ng-container *ngIf="is_loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>


<div [hidden]="is_auid_view">

        <div style="margin-top: 20px; margin-left: 20px">
          <form [formGroup]="myForm" (ngSubmit)="onSubmit()" autocomplete="off" novalidate>
            <mat-form-field>
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [rangePicker]="picker" [disabled]="is_running===true">
                <input matStartDate placeholder="Start date" (dateChange)="addDateEvent('start', $event)"
                       formControlName="start_date">
                <input matEndDate placeholder="End date" (dateChange)="addDateEvent('end', $event)"
                       formControlName="end_date">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <br>

            <div class="flex-container-submit">
            <button mat-raised-button color="primary" [disabled]="!myForm.valid || is_running===true" type="submit">Submit</button>
            <button mat-raised-button type="button" color="primary" *ngIf="is_running" (click)="stopRunning()" style="margin-left: 10px">Cancel</button>
            </div>
          </form>

        </div>



        <br>

        <ng-container *ngIf="is_data">
          <div style="margin-left: 20px" class="warn-icon-primary">
            <br>
            <label>No data for the selected time period</label>
          </div>
        </ng-container>

        <ng-container *ngIf="is_running===true">
          <div style="margin-left: 20px" class="warn-icon-primary">
            <br>
            <label>Depending on amount of traffic you get and the size of the date range; results can take 1-2 minutes</label>
          </div>
        </ng-container>

  <div>




  <!--<ng-container *ngIf="call_list.length>0 && is_data_loaded">-->
  <!--https://stackoverflow.com/questions/56028775/mat-paginator-breaks-when-mat-table-is-inside-of-ngif -->
  <div [hidden]="call_list.length==0 && is_data_loaded==false">

    <mat-expansion-panel >
      <mat-expansion-panel-header>
        <mat-panel-title>
          Calandar, Email, & Form Actions
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div style="margin-left: 20px;">
        <br>
        <mat-form-field appearance="standard">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
        </mat-form-field>

        <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
          <mat-card class="mat-elevation-z24">
            <!--        <mat-card-header>-->
            <!--          Campaigns-->
            <!--        </mat-card-header>-->

            <mat-card-content>


              <div class="mat-elevation-z24">
                <table mat-table [dataSource]="dataSource" matSort>

                  <!-- Provider Column -->
                  <ng-container matColumnDef="dt_utc">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                    <td mat-cell *matCellDef="let row"> {{row.dt_utc}} </td>
                  </ng-container>

                  <!-- Provider Column -->
                  <ng-container matColumnDef="provider">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Provider</th>
                    <td mat-cell *matCellDef="let row"> {{row.provider}} </td>
                  </ng-container>

                  <!-- Email Column -->
                  <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                    <td mat-cell *matCellDef="let row"> {{row.emailAddress}} </td>
                  </ng-container>

                  <!-- Phone Column -->
                  <ng-container matColumnDef="phoneNumberStandard">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
                    <td mat-cell *matCellDef="let row"> {{row.phoneNumberStandard}} </td>
                  </ng-container>


                  <!-- Fullname Column -->
                  <ng-container matColumnDef="fullname">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Full Name</th>
                    <td mat-cell *matCellDef="let row"> {{row.fullname}} </td>
                  </ng-container>


                  <!-- Star Column -->
<!--                  <ng-container matColumnDef="star" stickyEnd>-->
<!--                    <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>-->
<!--                    <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">-->
<!--                      <mat-icon>more_vert</mat-icon>-->
<!--                    </td>-->
<!--                  </ng-container>-->


                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"
                      (click)="getTableRecord(row)"></tr>

                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                  </tr>
                </table>

                <mat-paginator
                  [pageSize]="10"
                  [pageSizeOptions]="[5, 10, 25, 100]"
                  showFirstLastButtons>
                </mat-paginator>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

    </mat-expansion-panel>

  </div>
  <!--</ng-container>-->


  <!-- CLICKFUNNELS TABLE -->
  <div [hidden]="clickfunnels_list.length==0 && is_data_loaded==false">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Click Funnels Actions
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div style="margin-left: 20px;">
        <br>
        <mat-form-field appearance="standard">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilterSales($event)" placeholder="Ex. Mia" #input_sales>
        </mat-form-field>

        <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
          <mat-card class="mat-elevation-z24">
            <!--        <mat-card-header>-->
            <!--          Campaigns-->
            <!--        </mat-card-header>-->

            <mat-card-content>


              <div class="mat-elevation-z24">
                <table mat-table [dataSource]="dataSourceClickfunnel" matSort>

                  <!-- Date Column -->
                  <ng-container matColumnDef="dt_utc">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                    <td mat-cell *matCellDef="let row"> {{row.dt_utc}} </td>
                  </ng-container>

                  <!-- Provider Column -->
                  <ng-container matColumnDef="provider">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Provider</th>
                    <td mat-cell *matCellDef="let row"> {{row.provider}} </td>
                  </ng-container>

                  <!-- Email Column -->
                  <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                    <td mat-cell *matCellDef="let row"> {{row.emailAddress}} </td>
                  </ng-container>

                  <!-- Phone Column -->
                  <ng-container matColumnDef="phoneNumberStandard">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
                    <td mat-cell *matCellDef="let row"> {{row.phoneNumberStandard}} </td>
                  </ng-container>


                  <!-- Fullname Column -->
                  <ng-container matColumnDef="fullname">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Full Name</th>
                    <td mat-cell *matCellDef="let row"> {{row.fullname}} </td>
                  </ng-container>

                  <!-- Country Column -->
                  <ng-container matColumnDef="country">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
                    <td mat-cell *matCellDef="let row"> {{row.country}} </td>
                  </ng-container>

                  <ng-container matColumnDef="chargeDescription">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Charge Desc</th>
                    <td mat-cell *matCellDef="let row"> {{row.chargeDescription}} </td>
                  </ng-container>

                  <ng-container matColumnDef="charge_amount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Charge Amount</th>
                    <td mat-cell *matCellDef="let row"> {{row.charge_amount | currency}} </td>
                  </ng-container>

                  <ng-container matColumnDef="last_status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                    <td mat-cell *matCellDef="let row"> {{row.last_status}} </td>
                  </ng-container>


                  <!-- Star Column -->
<!--                  <ng-container matColumnDef="star" stickyEnd>-->
<!--                    <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>-->
<!--                    <td mat-cell *matCellDef="let element">-->
<!--                      <mat-icon>more_vert</mat-icon>-->
<!--                    </td>-->
<!--                  </ng-container>-->
                  <!-- Star Column -->
<!--                  <ng-container matColumnDef="star" stickyEnd>-->
<!--                    <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>-->
<!--                    <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">-->
<!--                      <mat-icon>more_vert</mat-icon>-->
<!--                    </td>-->
<!--                  </ng-container>-->


                  <tr mat-header-row *matHeaderRowDef="displayedColumnsClickfunnel"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsClickfunnel;" class="element-row"
                      (click)="getTableRecord(row)"></tr>

                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter "{{input_sales.value}}"</td>
                  </tr>
                </table>

                <mat-paginator
                  [pageSize]="10"
                  [pageSizeOptions]="[5, 10, 25, 100]"
                  showFirstLastButtons>
                </mat-paginator>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

    </mat-expansion-panel>
  </div> <!-- END CLICKFUNNELS TABLE -->

  <br>
  <br>

</div>

<!-- ########################################################### -->
<!-- ########################################################### -->
<!-- ########################################################### -->
<!-- ########################################################### -->
<!-- ########################################################### -->




</div>

<div [hidden]="!is_auid_view">

  <div style="margin-top: 20px; margin-left: 20px">

    <button mat-raised-button color="primary" (click)="goBack()">Back</button>
  </div>

  <br>

  <div [hidden]="journey_list.length==0 && is_journey_data_loaded==false">

    <div style="margin-left: 20px; width: 300px;">
      <br>
      <mat-form-field appearance="standard">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilterJourney($event)" placeholder="Ex. Mia" #input_journey>
      </mat-form-field>

      <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
        <mat-card class="mat-elevation-z24">
          <!--        <mat-card-header>-->
          <!--          Campaigns-->
          <!--        </mat-card-header>-->

          <mat-card-content>


            <div class="mat-elevation-z24">
              <table mat-table [dataSource]="dataSourceJourney" matSort>

                <ng-container matColumnDef="dt_utc">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                  <td mat-cell *matCellDef="let row"> {{row.dt_utc}} </td>
                </ng-container>

                <!-- Provider Column -->
                <ng-container matColumnDef="actionID">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                  <td mat-cell *matCellDef="let row"> {{row.actionID}} </td>
                </ng-container>

                <!-- Email Column -->
                <ng-container matColumnDef="provider">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Provider</th>
                  <td mat-cell *matCellDef="let row"> {{row.provider}} </td>
                </ng-container>

                <!-- Star Column -->
                <!--                <ng-container matColumnDef="star" stickyEnd>-->
                <!--                  <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>-->
                <!--                  <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">-->
                <!--                    <mat-icon>more_vert</mat-icon>-->
                <!--                  </td>-->
                <!--                </ng-container>-->


                <tr mat-header-row *matHeaderRowDef="displayedColumnsJourney"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsJourney;" class="element-row"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No data matching the filter "{{input_journey.value}}"</td>
                </tr>
              </table>

              <mat-paginator
                [pageSize]="10"
                [pageSizeOptions]="[5, 10, 25, 100]"
                showFirstLastButtons>
              </mat-paginator>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

</div>
